import React from 'react';
import { config, setCurrency, getCurrentCurrency } from '../config';

interface CurrencySelectorProps {
  onCurrencyChange?: () => void;
}

const CurrencySelector: React.FC<CurrencySelectorProps> = ({ onCurrencyChange }) => {
  const currentCurrency = getCurrentCurrency();

  const handleCurrencyChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const newCurrency = event.target.value as keyof typeof config.currencies;
    if (setCurrency(newCurrency)) {
      onCurrencyChange?.();
    }
  };

  return (
    <div className="currency-selector">
      <select
        id="currency-select"
        value={currentCurrency.code}
        onChange={handleCurrencyChange}
        className="currency-select"
      >
        {Object.entries(config.currencies).map(([code, currency]) => (
          <option key={code} value={code}>
            {currency.code} ({currency.symbol})
          </option>
        ))}
      </select>
    </div>
  );
};

export default CurrencySelector;
